import React, { useSyncExternalStore } from 'react';
import * as Toast from '@radix-ui/react-toast';
import { LAYER } from 'modules/Common/utils/layers';
import { subscribe, getSnapshot, dismissToast } from './toastStore';
import CgToast from './CgToast';

/**
 * Where the stack lives. One constant so moving the viewport is a one-line
 * change rather than a hunt through class strings (T9).
 */
export const TOAST_VIEWPORT_POSITION = 'fixed bottom-[16px] right-[16px]';

/**
 * The toast host. Mount exactly once, high in the tree.
 *
 * Radix gives us the parts that were hand-rolled before: swipe-to-dismiss,
 * pause on hover/focus, an F8 hotkey that jumps focus to the stack, and
 * correct `role=status`/`role=alert` announcements per severity.
 */
export default function CgToaster() {
  const toasts = useSyncExternalStore(subscribe, getSnapshot, getSnapshot);

  return (
    <Toast.Provider swipeDirection="right">
      {toasts.map((toast) => (
        <CgToast
          // `seq` changes when a duplicate folds in, remounting the toast so
          // its dismiss timer restarts and the entry animation re-pulses.
          key={`${toast.id}-${toast.seq}`}
          toast={toast}
          onDismiss={dismissToast}
        />
      ))}
      <Toast.Viewport
        // Above every reachable dialog rung: a save failure has to be readable
        // over the dialog that caused it.
        style={{ zIndex: LAYER.toast }}
        // `group/viewport` drives the progress-bar pause in CgToast: Radix
        // pauses every dismiss timer while the viewport is hovered or focused,
        // so the bars have to pause on the same signal, not per-toast hover.
        // A drawer with an action footer marks <body> while open; the stack
        // then sits above that footer instead of covering its buttons.
        className={`${TOAST_VIEWPORT_POSITION} [body[data-cg-drawer-footer]_&]:bottom-[88px] group/viewport m-0 flex w-[380px] max-w-[calc(100vw-32px)] list-none flex-col gap-2.5 p-0 outline-none`}
      />
    </Toast.Provider>
  );
}
